'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// components
import { ModalStepper } from 'dumb';
import BatchStepList from './components/globalRawIngredientsBatchList';

// phrases
import phrases from './../../globalRawIngredients.phrases';

class GlobalRawIngredientsModalBatch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showOverlay: false,
			overlayType: '',
			loadingModal: false
		};

		this.modalRef = React.createRef();

		// Binds
		this._batchSubmit = this._batchSubmit.bind(this);
	}

	_batchSubmit() {
		const { batchList, handleClose, rawIngredientCategory } = this.props;

		this.setState(() => ({
			loadingModal: true
		}));

		const payload = batchList.map(entry => {
			return {
				name: entry.name,
				description: entry.description,
				legacy: entry.legacy,
				raw_ingredient_category: rawIngredientCategory.id
			};
		});

		this.props
			.addGlobalRawIngredients({ batch: payload })

			.then(e => {
				handleClose();
				this.setState(() => ({
					loadingModal: false
				}));
			})
			.catch(e => {
				this.setState(() => ({
					loadingModal: false
				}));
			});
	}

	render() {
		const {
			modalVisible,
			handleClose,
			removeBatchListItem,
			editBatchListItem,
			batchList,
			addBatchListItemRow,
			rawIngredientCategory
		} = this.props;
		const { showOverlay } = this.state;

		const steps = [
			{
				component: (
					<BatchStepList
						batchList={batchList}
						editBatchListItem={editBatchListItem}
						removeBatchListItem={removeBatchListItem}
						addBatchListItemRow={addBatchListItemRow}
						rawIngredientCategory={rawIngredientCategory}
					/>
				),
				title: phrases.MODAL_BATCH_STEP_LIST_TITLE,
				isValid: true,
				onNext: () => this._batchSubmit(),
				loading: this.state.loadingModal,
				confirmButtonLabel: phrases.MODAL_BATCH_STEP_LIST_CONFIRM_BUTTON_LABEL,
				defaultStyles: false
			}
		];

		return (
			<>
				{modalVisible && (
					<ModalStepper
						className="modal-batch"
						ref={this.modalRef}
						isOpen={modalVisible}
						steps={steps}
						showStep={false}
						onClose={showOverlay ? () => {} : handleClose}
						closeConfirm
					/>
				)}
			</>
		);
	}
}

GlobalRawIngredientsModalBatch.propTypes = {
	modalVisible: PropTypes.bool,
	batchList: PropTypes.array,
	handleClose: PropTypes.func,
	addGlobalRawIngredients: PropTypes.func,
	editBatchListItem: PropTypes.func,
	removeBatchListItem: PropTypes.func,
	addBatchListItemRow: PropTypes.func,
	rawIngredientCategory: PropTypes.object
};

GlobalRawIngredientsModalBatch.defaultProps = {
	modalVisible: false,
	loading: false
};

export default GlobalRawIngredientsModalBatch;
